<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-30 16:23:02
 * @LastEditors: Francis
 * @LastEditTime: 2022-08-02 15:01:54
-->
<template>
  <div class="parts">
    <div class="head">
      <div class="nav">
        <img
          class="back"
          src="../../assets/workOrder/back.png"
          alt=""
          @click="onClickBack"
        />
        <p class="title">我的库存</p>
      </div>
      <van-tabs
        type="line"
        v-model="active"
        background="#44b1f9"
        color="#fff"
        title-active-color="#fff"
        title-inactive-color="#fff"
        @click="onClick"
      >
        <van-tab title="产品" :name="0"> </van-tab>
        <!-- <van-tab title="分派" :name='2'></van-tab> -->
        <van-tab title="配件" :name="1"></van-tab>
      </van-tabs>
    </div>
    <!-- 产品 -->
    <div class="cenbox" v-if="active == 0">
      <div class="chanl" v-for="(item, index) in partsf" :key="index">
        <div>{{ item.category }}</div>
        <div>{{ item.csn }}</div>
      </div>
    </div>
    <!-- 配件 -->
    <div class="cenbox" v-if="active == 1">
      <div class="chanl" v-for="(item, index) in productf" :key="index">
        <div>{{ item.category }}</div>
        <div>{{ item.num }}</div>
      </div>
    </div>
    <!--  -->
  </div>
</template>

<script>
import { stockad } from "@/utils/network/interface";
import Header from "@/components/Header";
export default {
  name: "",
  components: {
    Header,
  },
  props: {},
  data() {
    return {
      active: 0,
      productf: [], //产品2
      partsf: [], //配件  1
    };
  },
  computed: {},
  watch: {},
  created() {
    this.stockfrom();
  },
  mounted() {},
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    onClick(index) {
      console.log(index);
      //   this.active = index;
      //   this.tableList = [];
    },
    stockfrom() {
      stockad().then((e) => {
        console.log(e.data, "kucun");
        this.productf = e.data.filter((re) => {
          return re.type == 1;
        });
        this.partsf = e.data.filter((re) => {
          return re.type == 2;
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.parts {
  min-height: 100vh;
  .head {
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 104px;
    background: #44b1f9;
    padding-top: 36px;
    .nav {
      display: flex;

      .title {
        height: 16px;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 16px;
        margin: 0 auto;
        // margin-left: -26px;
      }

      .back {
        width: 18px;
        height: 18px;
        margin-top: -2px;
        margin-left: 8px;
      }

      div {
        width: 18px;
        margin-right: 8px;
      }
    }
    .title {
      font-size: 16px;
      text-align: center;
      line-height: 25px;
      height: 25px;
      color: #fff;
    }
  }
  .cenbox {
    padding: 120px 25px 30px;
    color: #666;
    .chanl {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 1px solid #e1e1e1;
    }
  }
}
</style>

